import { ArrayPath } from './ArrayPath'
import { getArrayPath } from './getArrayPath'

const targetPathIncludesCurrent = (
  currentPath: ArrayPath,
  targetPath: ArrayPath
) =>
  // Reached end without failing
  (currentPath[0] === undefined && targetPath[0] === undefined) ||
  // Current is simply passing, tail into next
  ((currentPath[0] === targetPath[0] ||
    targetPath[0] === '*' ||
    (targetPath[0] === '*i' && typeof currentPath[0] === 'number') ||
    (targetPath[0] === '*k' && typeof currentPath[0] === 'string')) &&
    targetPathIncludesCurrent(currentPath.slice(1), targetPath.slice(1))) ||
  // Double star, skip current check and look ahead at all possible partial paths after
  (targetPath[0] === '**' &&
    (targetPath[1] === undefined ||
      Array.from(new Array(currentPath.length + 1), (_, i) => i).some((i) =>
        targetPathIncludesCurrent(currentPath.slice(i), targetPath.slice(1))
      )))

const targetPathsIncludesCurrent = (
  currentPath: ArrayPath,
  targetPaths: ArrayPath[]
): boolean =>
  targetPaths.some((targetPath) =>
    targetPathIncludesCurrent(currentPath, targetPath)
  )

/**
 * If includedPaths is null, currenPath must only not be in excludedPaths. Else, checks path recursively, accounting for wildcards (** or *).
 * @param currentPath The path to check
 * @param includedPaths The paths that must include currentPath. If null, defaults to ["**"]
 * @param excludedPaths The paths that must not include currentPath. If null, defaults to []
 * @returns boolean
 */
export const checkPath = (
  currentPath: string | ArrayPath,
  includedPaths?: (string | ArrayPath)[] | null,
  excludedPaths?: (string | ArrayPath)[] | null
): boolean => {
  currentPath =
    typeof currentPath === 'string' ? getArrayPath(currentPath) : currentPath
  return (
    (!includedPaths ||
      targetPathsIncludesCurrent(
        currentPath,
        includedPaths.map((path) =>
          typeof path === 'string' ? getArrayPath(path) : path
        )
      )) &&
    (!excludedPaths ||
      !targetPathsIncludesCurrent(
        currentPath,
        excludedPaths.map((path) =>
          typeof path === 'string' ? getArrayPath(path) : path
        )
      ))
  )
}
